module.exports = __webpack_public_path__ + "img/sobre_territorio_matachaves_03.b197ee2a.png";